import { render, staticRenderFns } from "./relatorio-dashboards.vue?vue&type=template&id=936983e0&scoped=true&"
import script from "./relatorio-dashboards.vue?vue&type=script&lang=js&"
export * from "./relatorio-dashboards.vue?vue&type=script&lang=js&"
import style0 from "./relatorio-dashboards.vue?vue&type=style&index=0&id=936983e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "936983e0",
  null
  
)

export default component.exports